import customHeaders, { getSpace } from '../../../common/headers';
import { useState, useEffect, useRef } from 'react';
import {
  DropDownSelector,
  ButtonBasic,
  InputDinamycPlaceholder,
  CheckboxToggle,
  ButtonClose
} from '@lk-gtcom/ecomlab-components';
import { DynamicFormComponent } from '../../../components/DynamicFormComponent/DynamicFormComponent';
import { useDataTable } from '../../../common/hooks';
import { StepItem } from '../../../components/StepItem/StepItem';
import { fetchApiFilterVer3 } from '../../../common/filtersFunc';
import { TitlePage } from '../../../components/TitlePage/TitlePage';
import useGeneralStore from '../../../store/general';
import { MoonLoader } from 'react-spinners';
import './ModalCreateCampaignFromRules.scss';
import { options_prop_mp } from '../../../common/globalVariables';
import { StepPoints } from '../../../components/StepPoints/StepPoints';
import { fetchMasterBrandFilter, fetchMasterCategoryFilter } from '../../../common/filtersFunc'
import { RequestController } from '../../../common/filtersFunc';
import { usePushNotifications } from '../../../common/pushNotification';
import { periodWeek } from '../../../common/constant';
import { useResponseHandler } from '../../../common/auth';


const ModalCreateCampaignFromRules = ({
  setIsModal,
  currentСampaign,
  setCurrentСampaign
}) => {

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) }
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
  // Реф для хранения контроллера запросов
  const requestControllerRef = useRef(new RequestController());
  // Рефы
  const fileInputRef = useRef(null);

  // Обработка ошибок
  const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();

  const [apiData, setApiData] = useState([]);

  const [selectedMarketplace, setSelectedMarketplace] = useState(currentСampaign?.mp_id ?
    options_prop_mp.filter(({ value }) => value == currentСampaign?.mp_id)?.[0] : options_prop_mp[0]);

  // Фильтры - левая панель
  const [strategiesListEcom, setStrategiesListEcom] = useState([]);
  const [strategiesListOzon, setStrategiesListOzon] = useState([]);

  const current_api = currentСampaign?.api_id ? { label: currentСampaign?.api_name, value: currentСampaign?.api_id } : null
  const current_ecom_strategies = currentСampaign?.ecom_model_id ?
    strategiesListEcom.filter((item) => item?.value == currentСampaign?.ecom_model_id)?.[0]
    : null

  const current_ozon_strategies = currentСampaign?.ozon_model_id ?
    strategiesListOzon.filter((item) => item?.value == currentСampaign?.ozon_model_id)?.[0]
    : null

  const [selectedApi, setSelectedApi] = useState(current_api);
  const [selectedEcomStrategies, setSelectedEcomStrategies] = useState(current_ecom_strategies)
  const [selectedOzonStrategies, setSelectedOzonStrategies] = useState(current_ozon_strategies)

  const [selectedStrategies, setSelectedStrategies] = useState(currentСampaign ? {
    label: currentСampaign?.strategy?.name,
    value: currentСampaign?.strategy?.id,
    description: currentСampaign?.strategy?.description
  } : [])

  const [apiPage, setApiPage] = useState(1);
  const [apiQuery, setApiQuery] = useState('');
  const [title, setTitle] = useState(currentСampaign?.name || '');

  const [isCheck, setIsCheck] = useState(currentСampaign ? currentСampaign?.is_active : false);
  const [currentStep, setCurrentStep] = useState(1)

  const [isSave, setIsSave] = useState(currentСampaign?.id)

  // Атрибуты
  const [attrEcom, setAttrEcom] = useState([])
  const [attrOzon, setAttrOzon] = useState([])

  // Таблица
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );

  const paginatorRef2 = useRef();
  const [setTable2 = setTable, tableProps2 = tableProps, setTableFuncs2 = setTableFuncs] = useDataTable(
    paginatorRef2.current?.setTotal,
    paginatorRef2
  );
  const [loading2, setLoading2] = useState(false)
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;

  // Фильтры
  const curr_brand = currentСampaign?.strat_param_filter?.filter(({ param_id }) => param_id == 10)?.[0]
  const default_category = (selectedStrategies?.value == 7) ? curr_brand : [{ label: 'Все', value: 'all' }]

  const curr_category = currentСampaign?.strat_param_filter?.filter(({ param_id }) => param_id == 4)?.[0]
  const default_brand = (selectedStrategies?.value == 7) ? curr_category : [{ label: 'Все', value: 'all' }]

  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(default_category);
  const [selectedBrand, setSelectedBrand] = useState(default_brand);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [totalApi, setTotalApi] = useState(0);

  // Фильтры новые 
  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;
  // табы
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date())

  const [startDateTask, setStartDateTask] = useState(new Date());
  const [endDateTask, setEndDateTask] = useState(new Date())

  // Чекбокс
  const [isSetPeriod, setIsSetPeriod] = useState(false)

  const setDataFromJson = (
    json,
    page,
    setState,
    withAll = true,
    mapFunc = (el) => ({ label: el.name, value: el.id })
  ) => {
    const dataArr = json.map(mapFunc);
    if (page > 1) {
      setState((prev) => [...prev, ...dataArr]);
    } else {
      if (withAll) setState([...dataArr]);
      else setState([...dataArr]);
    }
  };

  const categoryFilter = () => {
    fetchApiFilterVer3({
      selectedSpace: selectedSpace?.value,
      setTable: setTotalApi,
      page: categoryPage,
      selectedShop: selectedMarketplace,
      apiData,
      selectedApi,
      selectedCategory,
      selectedBrand,
      set: setCategoryData,
      setCategoryData: (e) => setCategoryData(e),
      searchParam: categoryQuery,
      filter: 'category',
    });
  };

  useEffect(() => {
    categoryFilter();
  }, [categoryPage, categoryQuery]);


  // Создание задачи
  const fetchСreateСampaign = () => {
    setLoading(true);
    let url = `https://apps2.ecomru.ru:6448/api/v1/seller_promo/strategies`

    const body = JSON.stringify({
      name: title,
      api_id: selectedApi?.value,
      api_name: selectedApi?.label,
      ecom_model_id: selectedEcomStrategies?.value,
      ozon_model_id: selectedOzonStrategies?.value
    })

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {
        setCurrentСampaign(json)
        setIsSave(true)
      })
      .catch(handleRequestError)
      .finally(() => {
        setTimeout(() => setLoading(false), 1000);
      });
  };

  // Редактирование задачи
  const fetchChangeСampaign = () => {
    setLoading(true);
    let url = `https://apps1.ecomru.ru:4655/v1/price-tasks/${currentСampaign?.id}`

    const body = JSON.stringify({
      is_active: isCheck,
      name: title,
      strategy_id: selectedStrategies?.value,
      api_id: selectedApi,
      mp_id: selectedMarketplace?.value,
      start_at: isSetPeriod ? startDateTask : null,
      finish_at: isSetPeriod ? endDateTask : null,
      // strategy_id: paramsValues.map(({ param_id, value }) => ({ param_id, value })),
      // option_id_list: isCheckOptions,
      // option_params: optionValues
    })

    fetch(url, { body, method: 'PUT', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        // onCloseModal()
        setIsSave(true)
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 1000);
      });
  };

  // Получение стратегий Ecom
  const fetchGetStrategiesEcom = () => {
    let url = `https://apps2.ecomru.ru:6448/api/v1/seller_promo/ecom_models`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        const current_option = json.map(({ id, name, description }) => {
          return {
            label: name + (description ? ` (${description})` : ''),
            value: id
          }
        })
        setStrategiesListEcom(current_option)
      })
      .catch(handleRequestError);
  };

  // Получение стратегий Ozon
  const fetchGetStrategiesOzon = () => {
    let url = `https://apps2.ecomru.ru:6448/api/v1/seller_promo/ozon_models`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        const current_option = json.map(({ id, name, description }) => {
          return {
            label: name + (description ? ` (${description})` : ''),
            value: id
          }
        })
        setStrategiesListOzon(current_option)
      })
      .catch(handleRequestError);
  };

  // Получение атрибутов ecom
  const fetchGetAttrEcom = () => {
    let url = `https://apps2.ecomru.ru:6448/api/v1/seller_promo/strategies/${currentСampaign?.id}/ecom_attrs`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        if (json?.attributes) {
          setAttrEcom(json?.attributes.map((item) => {
            return ({
              ...item,
              attribute_name: item?.portal_name,
              data_type: item?.attr_type,
              id: item?.attr_model_id,
              possible_values: item?.enum_values,
              required: item?.is_required,
              filter_link: item?.filter_url_front
            })
          }))
        }
      })
      .catch(handleRequestError);
  };

  // Сохранение значений атрибутов Ecom
  const fetchSetAttrEcom = () => {
    let url = `https://apps2.ecomru.ru:6448/api/v1/seller_promo/strategies/${currentСampaign?.id}/ecom_attrs`

    const current_field = attrEcom.map((item) => {
      return ({
        ...item,
        portal_name: item?.attribute_name,
        attr_type: item?.data_type,
        attr_model_id: item?.id,
        enum_values: item?.possible_values,
        is_required: item?.required,
        filter_link: item?.filter_url_front
      })
    })

    const body = JSON.stringify({
      attributes: current_field
    })

    fetch(url, { method: 'POST', headers, body })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) {
          const errorMessage = data.detail || res.statusText;
          addErrorPush(`Ошибка: ${errorMessage == 'Incorrect link format' ? 'Неверный формат ссылки' : errorMessage}`);
          throw new Error(`${res.status} ${errorMessage}`);
        }
        return data;
      })
      .then((json) => {
        addSuccessPush('Поля для ecom обновлены')
      })
      .catch(handleRequestError);
  };

  // Получение атрибутов ozon
  const fetchGetAttrOzon = () => {
    let url = `https://apps2.ecomru.ru:6448/api/v1/seller_promo/strategies/${currentСampaign?.id}/ozon_attrs`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        if (json?.attributes) {
          setAttrOzon(json?.attributes.map((item) => {
            return ({
              ...item,
              attribute_name: item?.portal_name,
              data_type: item?.attr_type,
              id: item?.attr_model_id,
              possible_values: item?.enum_values,
              required: item?.is_required
            })
          }))
        }
      })
      .catch(handleRequestError);
  };

  // Сохранение значений атрибутов
  const fetchSetAttrOzon = () => {
    let url = `https://apps2.ecomru.ru:6448/api/v1/seller_promo/strategies/${currentСampaign?.id}/ozon_attrs`

    const current_field = attrOzon.map((item) => {
      return ({
        ...item,
        portal_name: item?.attribute_name,
        attr_type: item?.data_type,
        attr_model_id: item?.id,
        enum_values: item?.possible_values,
        is_required: item?.required
      })
    })

    const body = JSON.stringify({
      attributes: current_field
    })

    fetch(url, { method: 'POST', headers, body })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) {
          const errorMessage = data.detail || res.statusText;
          addErrorPush(`Ошибка: ${errorMessage == 'Incorrect link format' ? 'Неверный формат ссылки' : errorMessage}`);
          throw new Error(`${res.status} ${errorMessage}`);
        }
        return data;
      })
      .then((json) => {
        addSuccessPush('Поля для ozon обновлены')
      })
      .catch(handleRequestError);
  };

  // Тогл
  const fetchChangeStatusTask = (status) => {
    let url = `https://apps2.ecomru.ru:6448/api/v1/seller_promo/strategies/${currentСampaign?.id}/status`

    const body = JSON.stringify({
      is_active: status
    })

    fetch(url, { method: 'PATCH', headers, body })
      .then(handleTableResponse)
      .then((json) => { })
      .catch(handleRequestError)
  }

  const onCloseModal = () => {
    setIsModal(false)
    setCurrentСampaign(null)
  }

  // Заполнение стратегий
  useEffect(() => {
    if (current_ecom_strategies) {
      setSelectedEcomStrategies(current_ecom_strategies);
    }
  }, [current_ecom_strategies]);

  useEffect(() => {
    if (current_ozon_strategies) {
      setSelectedOzonStrategies(current_ozon_strategies);
    }
  }, [current_ozon_strategies]);

  // Начало и конец задачи
  useEffect(() => {
    const start_time = currentСampaign?.start_at
    const end_time = currentСampaign?.finish_at

    if (start_time) {
      setStartDateTask(new Date(start_time))
      setIsSetPeriod(true)
    }
    if (end_time) {
      setEndDateTask(new Date(end_time))

    }
    setIsSetPeriod((start_time && end_time) ? true : false)
  }, [currentСampaign]);


  useEffect(() => {
    fetchGetStrategiesEcom()
    fetchGetStrategiesOzon()
  }, [selectedMarketplace, selectedApi]);

  const apiFilter = () => {
    fetchApiFilterVer3({
      selectedSpace: selectedSpace?.value,
      page: apiPage,
      setApiData: setApiData,
      set: setApiData,
      searchParam: apiQuery,
      selectedApi,
      selectedShop: selectedMarketplace,
      filter: 'api_id',
    });
  };

  useEffect(() => {
    apiFilter();
  }, [apiPage, apiQuery]);

  const isDisabled = !selectedEcomStrategies || !selectedOzonStrategies


  useEffect(() => {
    if (!(selectedStrategies?.value && title)) {
      setCurrentStep(1)
    }
  }, [selectedStrategies, title]);


  const currentCountStep = () => {
    return 3
  }

  useEffect(() => {
    if (currentСampaign) {
      setCurrentStep(2)
    }
  }, [currentСampaign]);


  useEffect(() => {
    if (currentСampaign?.id) {
      fetchGetAttrEcom()
      fetchGetAttrOzon()
    }
  }, [currentСampaign]);

  const disabled_ozon_btn = attrOzon.some((item) => {
    return item?.required && !item?.value // есть обязательное поле без значения
  })
  const disabled_ecom_btn = attrEcom.some((item) => {
    return item?.required && !item?.value // есть обязательное поле без значения
  })



  return (
    <>
      <div
        className="blackout blackout-modal"
        onClick={(e) => {
          let el = e.target;
          if (el.classList.contains('blackout-modal')) {
            onCloseModal()
          }
        }}
      >
        <div className="modal-create-campaign-from-rules"
        >
          <div className="modal-create-campaign-from-rules__header">
            <TitlePage
              title={currentСampaign
                ? `Редактирование стратегии`
                : `Добавление новой стратегии`}
            />

            <label className="modal-create-campaign-from-rules__label">
              <CheckboxToggle
                text='Активно'
                value={isCheck}
                onChange={(e) => {
                  fetchChangeStatusTask(!isCheck)
                  setIsCheck(!isCheck)
                }}
              />
            </label>

            <ButtonClose
              onClick={(e) => {
                onCloseModal()
              }}
            />
          </div>

          <div className="modal-create-campaign-from-rules__main-content">
            <div className="modal-create-campaign-from-rules__left-content">
              <TitlePage
                medium
                title='Общие параметры'
              />

              <InputDinamycPlaceholder
                position="left"
                maxWidth="100%"
                isOpen={true}
                onChange={(value) => {
                  setTitle(value)
                  setIsSave(false)
                  setCurrentStep(1)
                }}
                changeValue={title}
                placeholder="Введите название кампании"
                size="s"
                required={true}
              />

              <div className="modal-create-campaign-from-rules__select-group">
                <DropDownSelector
                  state={selectedApi}
                  options_prop={apiData}
                  total={totalApi}
                  setState={(e) => {
                    setSelectedApi(e)
                    setIsSave(false)
                    setCurrentStep(1)
                  }}
                  placeholder="Магазин"
                  fetchCallback={setApiPage}
                  setInputChange={setApiQuery}
                  required={true}
                  disabled={currentСampaign}
                />
              </div>

              <TitlePage
                medium
                title='Выбор стратегии'
              />

              <DropDownSelector
                state={selectedEcomStrategies}
                options_prop={strategiesListEcom}
                setState={(e) => {
                  setSelectedEcomStrategies(e)
                  setIsSave(false)
                  setCurrentStep(1)
                }}
                placeholder="Ecom стратегия"
                required={true}
                disabled={currentСampaign}
              // disabled={currentСampaign}
              />

              <DropDownSelector
                state={selectedOzonStrategies}
                options_prop={strategiesListOzon}
                setState={(e) => {
                  setSelectedOzonStrategies(e)
                  setIsSave(false)
                  setCurrentStep(1)
                }}
                placeholder="Ozon стратегия"
                required={true}
                disabled={currentСampaign}
              // disabled={currentСampaign}
              />

              <ButtonBasic
                green
                text="Сохранить"
                size='56px'
                onClick={(e) => {
                  if (currentСampaign) {
                    fetchChangeСampaign()
                    if (isSave) {
                      onCloseModal()
                    }
                  } else {
                    fetchСreateСampaign()
                  }
                }}
                style={{ marginTop: 'auto' }}
                disabled={isDisabled}
              />
            </div>

            <div className="modal-create-campaign-from-rules__right-content">
              <div className='modal-create-campaign-from-rules__toolbar'>
                <StepPoints
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  totalSteps={currentCountStep()}
                />

                <ButtonBasic
                  green
                  text="Следующий щаг"

                  onClick={(e) => {
                    setCurrentStep(currentStep + 1)
                  }}
                  disabled={isDisabled || (currentStep === currentCountStep())}
                />
              </div>


              {(currentStep === 1) && <StepItem
                title='Шаг 1: Выбери стратегию '
                description={
                  <>
                    Заполните все обязательные поля, которые находятся ниже и
                    нажмите на кнопку <span style={{ color: '#22C55E' }}> “Сохранить”.</span>
                    <span style={{ color: 'red' }}>
                      {' '}
                      Красными звездочками
                    </span>{' '}
                    выделены обязательные пункты для заполнения</>}
              />}


              {currentStep === 2 &&
                <>
                  <StepItem
                    title={`Шаг 2: Заполните атрибуты`}
                  />

                  <div className="prepared_scenarios__content">
                    <TitlePage
                      medium
                      title={'Атрибуты Ecom'}
                    />

                    <DynamicFormComponent
                      api_id={selectedApi?.value}
                      productTemporary={attrEcom}
                      setProductTemporary={setAttrEcom}
                    />

                    <ButtonBasic
                      blue
                      text='Сохранить'
                      onClick={fetchSetAttrEcom}
                      disabled={disabled_ecom_btn}
                    />
                  </div>
                </>
              }

              {currentStep === 3 &&
                <>
                  <StepItem
                    title={`Шаг 3: Заполните атрибуты`}
                  />

                  <div className="prepared_scenarios__content">
                    <TitlePage
                      medium
                      title={'Атрибуты Ozon'}
                    />

                    <DynamicFormComponent
                      productTemporary={attrOzon}
                      setProductTemporary={setAttrOzon}
                    />

                    <ButtonBasic
                      blue
                      text='Сохранить'
                      onClick={fetchSetAttrOzon}
                      disabled={disabled_ozon_btn}
                      style={{minHeight: '40px'}}
                    />
                  </div>
                </>
              }
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export { ModalCreateCampaignFromRules };

// <FiltersWrapper
//   {...item}
//   key={item.ecom_model_id}
//   id={item.ecom_model_id}
//   type={item.attr_type}
//   service_id={1}
//   placeholder={item.portal_name}
//   selectedData={filterValues}
//   onFilterChange={handleFilterChange}
//   edit={false}
// />